<template>
    <div class="contanier">
        <div class="contanier_mask"></div>

        <div class="loginForm">
            <div class="form_header">
                <!-- <img class="logoImg" src="@/assets/image/index-banner-Icon.webp" alt="" width="40" height="50" > -->
                <img class="logoImg2" src="@/assets/image/hepha-logo-black2.jpg" alt="" width="200" height="70" >
                <a-select 
                    v-model="language"
                    :style="{width:'120px',float:'right',marginTop:'10px'}" 
                    placeholder="Select"
                    @change="changeSelect"
                >
                    <a-option value="en">English</a-option>
                    <!-- <a-option value="de">Deutsch</a-option> -->
                    <a-option value="zh">简体中文</a-option>
                </a-select>
                <div class="text">{{ $t('signUp.title') }}</div>
                <div class="subText">{{ $t('signUp.subTitle') }}</div>
            </div>
            <div>
                <a-form
                    :model="form"
                    :style="{marginTop: '10px' }"
                    :size="size"
                >
                    <a-form-item
                        field="name"
                        :hide-label="true"
                        :help="userMsg"
                        :validate-status="username_status"
                        feedback
                    >
                        <a-input
                            v-model="form.user_name"
                            allow-clear
                            :placeholder="$t('base.username')"
                        />
                    </a-form-item>
                    <a-form-item
                        field="email"
                        :hide-label="true"
                        :help="emailMsg"
                        :validate-status="email_status"
                        feedback
                    >
                        <a-input
                            v-model="form.email"
                            allow-clear
                            :placeholder="$t('base.email')"
                        />
                    </a-form-item>
                    <a-form-item
                        field="password"
                        :hide-label="true"
                        :help="pdwMsg"
                        :validate-status="password_status"
                        feedback
                    >
                        <a-input-password
                            v-model="form.password"
                            allow-clear
                            :placeholder="$t('signUp.password')"
                            @input="inputPassword"
                            @change="changePassword"
                        />
                       
                    </a-form-item>
                    <span class="passwordVaildMsg">{{ $t('signUp.passwordVaildMsg') }}</span>
                    <a-button type="primary" class="signInBtn" :disabled="disabledSignUp" @click="beforeSignUp">{{ $t('base.signUp') }}</a-button>
                </a-form>
            </div>
            <div class="form_footer">
                {{ $t('signUp.bottomTitle') }} <router-link to="/Login" class="link">{{ $t('base.login') }}</router-link> 
            </div>

            <Verify
                class="verify"
                @success="success" 
                mode="pop" 
                captchaType="blockPuzzle"
                :imgSize="{ width: '408px', height: '155px' }"
                ref="verifyRef"
            ></Verify>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { LoginApi } from '@/api/LoginApi.js';
    import { Message } from '@arco-design/web-vue';
    import { useI18n } from 'vue-i18n';
    import Verify from "@/components/verifition/Verify";


    const router = useRouter()
    const { t } = useI18n()

    const language = localStorage.getItem('locale')? ref(localStorage.getItem('locale')) : ref('en')
    const userMsg = ref('')
    const emailMsg = ref('')
    const pdwMsg = ref('')
    const username_status = ref('')
    const email_status = ref('')
    const password_status = ref('')
    const disabledSignUp = ref(true)
    const form = reactive({
        captcha_verification:'',
        user_name:'',
        email:'',
        password:'',
        category:0, // 默认为0
    })
    const verifyRef = ref(null)


    const changeSelect = (val)=>{
        localStorage.setItem('locale',val)
        location.reload()
    }

    // 校验密码是否合规
    const changePassword = (val)=>{
        let pattern =  /(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/
        let bool = pattern.test(val)
        if(!bool){
            pdwMsg.value = t('signUp.passwordVaildMsg')
            password_status.value = 'error'
        }
    }

    const inputPassword = (val)=>{
        let pattern =  /(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/
        disabledSignUp.value = !pattern.test(val)
    }

    const vaild = ()=>{
        let pattern =  /(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/
        let pwd_bool = pattern.test(form.password)

        let email_pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,}$/
        let email_bool = email_pattern.test(form.email)

        if(!form.user_name && !form.email && !form.password){
            userMsg.value = t('login.usernameEmpty')
            username_status.value = 'error'
            emailMsg.value = t('signUp.emailEmpty')
            email_status.value = 'error'
            pdwMsg.value = t('login.passwordEmpty')
            password_status.value = 'error'

            return false
        }else if(!form.user_name){
            userMsg.value = t('login.usernameEmpty')
            username_status.value = 'error'
            return false
        }else if(!form.email){
            emailMsg.value = t('signUp.emailEmpty')
            email_status.value = 'error'
            return false
        }else if(!form.password){
            pdwMsg.value = t('login.passwordEmpty')
            password_status.value = 'error'
            return false
        }else if(!pwd_bool){
            pdwMsg.value = t('signUp.passwordVaildMsg')
            password_status.value = 'error'
            return false
        }else if(!email_bool && form.email){
            emailMsg.value = t('signUp.error_email')
            email_status.value = 'error'
            return false
        }

        return true
    }   

    // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    const success = (params)=>{ 
        // console.log(params,'params')
        form.captcha_verification = params.captchaVerification
        vaildEmail()
    }

    const beforeSignUp = ()=>{
        if(!vaild()) return

        if(form.captcha_verification == ''){
            verifyRef.value.show()
            return
        }
    }

    // 校验邮箱是否已被注册
    const vaildEmail = async ()=>{
        let res = await LoginApi.getInstance().vaildEmail({email:form.email, captcha_verification:form.captcha_verification})
        if(res.code == 0){
            emailMsg.value = t('')
            email_status.value = ''

            signUp()
        }else{
            form.captcha_verification = ''
            emailMsg.value = t(res.msg)
            email_status.value = 'error'
        }
    }

    // 注册
    const signUp = async ()=>{
        let res = await LoginApi.getInstance().register(form)
        if(res.code == 0){
            Message.success(t('signUp.tip'))
            router.replace('/Login')
        }else{
            form.captcha_verification = ''
            Message.error(res.msg)
        }
    }

    watch(()=>form.user_name, (val)=>{
        if(val){
            userMsg.value = ''
            username_status.value = ''
        }
    })

    watch(()=>form.email, (val)=>{
        if(val){
            emailMsg.value = ''
            email_status.value = ''
        }
    })

    watch(()=>form.password, (val)=>{
        if(val){
            pdwMsg.value = ''
            password_status.value = ''
        }
    })

    onMounted(()=>{
        
    })


</script>

<style lang="less" scoped>
.contanier{
    width: 100%;
    height: 100vh;
    background:url('@/assets/image/login_bg.webp');

    .contanier_mask{
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0.6;
    }

    .loginForm{
        position: absolute;
        top: 50%;
        left: 50%;
        z-index:1001;
        margin-left: -35vh;
        margin-top: -40vh;
        padding: 45px;
        width: 70vh;
        height: auto;
        box-sizing: border-box;
        background: #fff;
        border-radius: 5px; 

        .logoImg2{
            margin-left: -25px;
            vertical-align: top;
            margin-top:18px;
        }

        .text{
            margin-top: 20px;
            font-size: 18px;
            font-weight: 600;
        }
        .subText{
            margin-top: 5px;
            font-weight: 300;
            color: #333;
        }

        /deep/ .arco-form-item-content-wrapper{
            margin-top: 15px;
        }

        /deep/ .arco-input-wrapper .arco-input{
            height: 40px;
        }

        /deep/ button:focus, 
        /deep/ button:focus-visible{
            outline: none;
        }

        .signInBtn{
            margin-top: 20px;
            height: 50px;
        }
        .form_footer{
            margin-top: 20px;
            width: 90%;
            text-align: center;
            font-size: 16px;
            font-weight: 300;
            box-sizing: border-box;

            .link{
                color: #4d83ff;
            }
        }
        
        .passwordVaildMsg{
            font-size: 12px;
            color: #666;
        }
    }
}
</style>